export const SUPPORT_EMAIL = "support@pathologywatch.com";
export const SUPPORT_EMAIL_MAILTO = `mailto:${SUPPORT_EMAIL}`;
